module.exports = __webpack_public_path__ + "static/media/059-gabon.76c026b5.svg";